import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '~components';
import Icon, { faFileLines } from '~components/icon';

interface ComponentProps {
  value?: string | number | null;
}

const FormInputClaimLink: React.FC<ComponentProps> = ({ value }) => {
  const navigate = useNavigate();

  if (!value) return null;

  return (
    <Button
      color="success"
      size="sm"
      data-cy="appointment-view-claim-button"
      onClick={() => navigate(`/support-at-home/claims/${value}`)}
    >
      <Icon icon={faFileLines} className="me-1" />
      View Claim
    </Button>
  );
};

export default FormInputClaimLink;
